import React, { FC, useCallback, useEffect, useState } from 'react';
import { styled } from 'linaria/lib/react';
import { useRouter } from 'next/router';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
import { Payee } from '@root/api/ump-catalog-manager';
import { authHelper } from '@root/utils/authHelper/AuthHelper';
import { authData } from '@root/utils/authHelper/authData';
import { CyberAutoComplete } from '../CyberAutoComplete/CyberAutoComplete';
import { CyberLogo } from '../CyberLogo/CyberLogo';
import { StickySearch } from './StickySearch';
import { AuthParams } from '../Auth/types';
import { PaymentButton } from './buttons/PaymentButton';
import { Burger } from '../BurgerMenu/Burger';
import { triggerCsvReportSend } from './utils/triggerCsvReportSend';
interface ICyberHeader {
  servicesAll: Payee[];
}
export const CyberHeader: FC<ICyberHeader> = ({
  servicesAll
}) => {
  const [logPrices] = useState(typeof sessionStorage !== 'undefined' && (sessionStorage.getItem('logPrices') || false));
  const router = useRouter();
  const isAuth = authHelper.isAuthenticated();
  // const { isMobile } = useBreakpoint()

  const [, setShowTooltip] = useState<boolean>(typeof sessionStorage !== 'undefined' && sessionStorage.getItem('tooltipShown') !== 'true');
  const [isSendingCsv, setIsSendingCsv] = useState(false);
  useEffect(() => {
    const tooltipShown = window.sessionStorage.getItem('tooltipShown');
    if (tooltipShown) {
      setShowTooltip(false);
    } else {
      window.sessionStorage.setItem('tooltipShown', 'true');
    }
  }, []);
  const shouldNotSearch = useCallback(() => {
    const notSearchURL = [];
    return notSearchURL.some((url: string) => router.pathname.includes(url));
  }, [router.pathname]);

  // const handleLogIn = () => {
  //   if (!isAuth) {
  //     authHelper.onSignIn()
  //     authHelper.mtsIdAuthorize(authData() as AuthParams).then((mtsId) => {
  //       authHelper.redirectTo(mtsId)
  //     })
  //   }
  // }

  const handleSendCsvClick = async () => {
    setIsSendingCsv(true);
    try {
      await triggerCsvReportSend();
    } catch (error) {
      console.error('Ошибка при запуске отправки CSV:', error);
    } finally {
      setIsSendingCsv(false);
    }
  };
  return <SearchWrraper id="header">
      <CyberLogoWrapper>
        <CyberLogo />
      </CyberLogoWrapper>
      <WrapperSearchLogin>
        <CyberAutoCompleteWrapper shouldNotSearch={shouldNotSearch}>
          <CyberAutoComplete servicesAllServer={servicesAll} />
        </CyberAutoCompleteWrapper>
        {logPrices && <PaymentButton title="Логи цен" onClick={handleSendCsvClick} isAmountInfoLoading={isSendingCsv} disabled={isSendingCsv} height={40} width={115} />}
        {isAuth && <Burger />

      // : (
      //   <ToolTipText
      //     asWrapper
      //     noIcon
      //     maxWidth="312px"
      //     hint={
      //       <AuthTooltip
      //         title="Авторизуйтесь по МТС ID"
      //         subtitle="Вы сможете пополнять аккаунт с мобильного счёта МТС"
      //         icon={<Image aria-hidden objectFit="contain" width={72} height={72} alt="icon" src={authIcon} />}
      //       />
      //     }
      //     placement="bottom-end"
      //     visible={false}
      //     onHidden={() => setShowTooltip(false)}
      //   >
      //     <PaymentButton
      //       logIn
      //       title={isMobile ? '' : 'Войти'}
      //       onClick={handleLogIn}
      //       height={40}
      //       width={isMobile ? 44 : 115}
      //     />
      //   </ToolTipText>
      }
      </WrapperSearchLogin>
      <StickySearch>
        <CyberAutoComplete servicesAllServer={servicesAll} />
      </StickySearch>
    </SearchWrraper>;
};
const SearchWrraper = /*#__PURE__*/styled("div")({
  name: "SearchWrraper",
  class: "s1msm3e0"
});
const CyberLogoWrapper = /*#__PURE__*/styled("div")({
  name: "CyberLogoWrapper",
  class: "cs5itkz"
});
const WrapperSearchLogin = /*#__PURE__*/styled("div")({
  name: "WrapperSearchLogin",
  class: "w1odjsj9"
});
const CyberAutoCompleteWrapper = /*#__PURE__*/styled("div")({
  name: "CyberAutoCompleteWrapper",
  class: "c12jccub",
  vars: {
    "c12jccub-0": [({
      shouldNotSearch
    }) => shouldNotSearch() ? 'none' : 'block']
  }
});

require("./CyberHeader.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberHeader.tsx");